import { Container, FormControl, InputLabel, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import { Box, Typography, Select } from "@mui/material";
import SubmitButton from "../components/common/SubmitButton";
//import Checkbox from '../components/Base/Checkbox/index';
import { useNavigate, useLocation } from "react-router-dom";
import Input from "../components/Base/Input/index";
import configData from "../Config";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import CustSelect from "../components/Base/Select";
import { apis } from "../services/apiService";
import CustomSelectStyle from "../components/Base/Select/style";
import styles from "../Style/Modules/bankDetails.module.css";
import "../Style/Theme/index.css";
import { VerifyAccNo, isValidIfsc } from "../utils/utils";
import AlertPopup from "../components/common/AlertPopup";
import CustAutoComplete from "../components/Base/AutoComplete";

export default function BankDetails() {
  const initialdata = {
    accountNo: "",
    reAccountNo: "",
    ifsc: "",
    accountType: "Savings",
    bankName: null,
    paymentType: null,
    variantType: null,
  };

  const navigate = useNavigate();
  let location = useLocation();
  const [formData, setFormData] = useState(initialdata);
  const [accountErr, setAccountErr] = useState("");
  const [reAccountErr, setReAccountErr] = useState("");
  const [ifscErr, setifscErr] = useState("");
  const [finalErr, setFinalErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [validateEnachList, setValidateEnachList] = useState([]);
  const [variantTypeList, setVariantTypeList] = useState([]);
  const [paymentTypeList, setPaymentTypeList] = useState([]);

  const getBankList = async () => {
    setLoading(true);
    try {
      const resp = await apis.getApi(
        configData.API_URL + "ApplicationFlow/GetBanks"
      );
      if (resp?.status === 200) {
        let result = await resp?.json();
        setBankList(result.data);
        setLoading(false);
      } else {
        setBankList([]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
    }
  };

  useEffect(() => {
    getBankList();
  }, []);

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        aid: location?.state?.AppId,
        acc: formData?.accountNo,
        ifsc: formData?.ifsc,
        atype: formData?.accountType,
        bankId: formData?.bankName?.id,
        paymentType: formData?.paymentType?.paymentType,
        variantType: formData?.variantType?.variant,
      };

      let resp = await apis.postApi(
        // configData.API_URL + "Enach/DigioAddEnachBank",
        configData.API_URL + "Enach/PaynioEnach",
        reqData
      );
      let result = await resp?.json();
      if (resp?.status === 200) {
        setLoading(false);
        // // start for degio enach
        // let sresult = JSON.parse(result?.data);
        // let data = {
        //   AppId: location.state.AppId,
        //   statusMessage: sresult.statusMessage,
        //   short_url: sresult.short_url,
        //   mandate_id: sresult.mandate_id,
        // };
        // navigate("/pending-enach", { state: data });
        // end for degio enach
        // // end for degio enach

        // start for ingenico enach
        let data = {
          AppId: location.state.AppId,
        };
        navigate("/pending-enach", { state: data });
        // End for ingenico enach
      }
    } catch (error) {
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
    }
  };

  const handleOnchange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
    if (e?.target?.name === "accountNo") {
      if (e?.target?.value && !VerifyAccNo(e?.target?.value)) {
        setAccountErr("Invalid account number");
      } else {
        setAccountErr("");
      }
    }
    if (e?.target?.name === "reAccountNo") {
      if (e?.target?.value !== formData?.accountNo) {
        setReAccountErr("Account number not matched");
      } else {
        setReAccountErr("");
      }
    }
    if (e?.target?.name === "ifsc") {
      if (e?.target?.value && !isValidIfsc(e?.target?.value)) {
        setifscErr("please enter valid IFSC Code");
      } else {
        setifscErr("");
      }
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
    setFormData({
      ...formData,
      ["bankName"]: null,
    });
  };

  const getValidateEnachBank = async (data) => {
    try {
      setLoading(true);
      let resp = await apis?.getApi(
        `${configData.API_URL}ApplicationFlow/ValidateENachBank?bankId=${data?.id}`
      );
      if (resp?.status === 200) {
        let result = await resp?.json();
        setLoading(false);
        setValidateEnachList(result?.data);
        const uniqueVariantType = [
          ...new Set(result?.data?.map((item) => item.variant)),
        ];
        const uniqueObjects = uniqueVariantType?.map((variant, index) => {
          return { id: index + 1, variant };
        });
        setVariantTypeList(uniqueObjects);
      }
    } catch (error) {
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMesage);
    }
  };

  const handleBankAutoComp = (e, data, reason) => {
    if (reason !== "clear") {
      if (data) {
        getValidateEnachBank(data);
        setFormData({
          ...formData,
          ["bankName"]: data,
          ["variantType"]: null,
          ["paymentType"]: null,
          ["ifsc"]: "",
        });
      }
    } else {
      setVariantTypeList([]);
      setPaymentTypeList([]);
      setFormData({
        ...formData,
        ["bankName"]: null,
        ["variantType"]: null,
        ["paymentType"]: null,
        ["ifsc"]: "",
      });
    }
  };

  const handleVariantTypeAutoComp = (e, data, reason) => {
    if (reason !== "clear") {
      if (data) {
        const filterPaymentData = validateEnachList?.filter((arrData) => {
          return arrData.variant === data?.variant;
        });
        setPaymentTypeList(filterPaymentData);
        setFormData({ ...formData, ["variantType"]: data });
      }
    } else {
      setFormData({
        ...formData,
        ["variantType"]: null,
        ["paymentType"]: null,
      });
    }
  };

  const handlePayTypeAutoComp = (e, data, reason) => {
    if (reason !== "clear") {
      if (data) {
        setFormData({ ...formData, ["paymentType"]: data });
      }
    } else {
      setFormData({ ...formData, ["paymentType"]: null });
    }
  };

  return (
    <>
      <Header showBar={true} step={10} />
      <Container maxWidth={false} className="container_Th">
        <IntroCard
          title="Bank Details"
          subtitle="Bank details for ENACH"
          img="/assets/notepad.svg"
        />
        <form
          component="form"
          noValidate
          id="BankDetails"
          onSubmit={handleSubmit}
          autoComplete="off"
          className={styles.bankDetailsForm}
        >
          <Box className={styles.bankDetailsBox}>
            <Input
              type="password"
              name="accountNo"
              label="Account Number"
              value={formData?.accountNo}
              autoComplete="off"
              onChange={handleOnchange}
            />
            {accountErr && (
              <Box mt={-3} ml={0}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {accountErr}
                </Typography>
              </Box>
            )}
            <Input
              type="text"
              name="reAccountNo"
              autoComplete="off"
              label="Re-Enter Account Number"
              value={formData?.reAccountNo}
              onChange={handleOnchange}
              disabled={!formData?.accountNo || accountErr}
            />
            {reAccountErr && (
              <Box mt={-3} ml={0}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {reAccountErr}
                </Typography>
              </Box>
            )}
            <CustAutoComplete
              styles={{ marginBottom: "32px" }}
              label="Select Bank"
              key="selectBankId"
              value={formData?.bankName}
              options={bankList}
              optionLabelName={"bankName"}
              uniqueKey={"id"}
              onChange={handleBankAutoComp}
              disabled={!formData?.reAccountNo || reAccountErr}
            />
            <Input
              type="text"
              name="ifsc"
              label="IFSC"
              autoComplete="off"
              value={formData?.ifsc}
              onChange={handleOnchange}
              disabled={!formData?.bankName}
            />
            {ifscErr && (
              <Box mt={-4} ml={0} mb={1}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {ifscErr}
                </Typography>
              </Box>
            )}
            <CustSelect
              name="accountType"
              label="Account type"
              labelId="accountTypeLabel"
              // value={formData?.accountType}
              id="accountType"
              handleChange={handleOnchange}
              items={["Savings", "Current"]}
              disabled={!formData?.ifsc || ifscErr}
            />
            <CustAutoComplete
              styles={{ marginBottom: "32px" }}
              label="Variant Type"
              key="vType"
              value={formData?.variantType}
              options={variantTypeList}
              optionLabelName={"variant"}
              uniqueKey={"code"}
              onChange={handleVariantTypeAutoComp}
              disabled={!formData?.ifsc || ifscErr}
            />
            <CustAutoComplete
              styles={{ marginBottom: "32px" }}
              label="Select Payment Type"
              key="id"
              value={formData?.paymentType}
              // options={
              //   formData?.variantType?.Variant === "ENACH"
              //     ? paymentTypeList
              //     : aadharPayTypeList
              // }
              options={paymentTypeList}
              optionLabelName={"paymentType"}
              uniqueKey={"Code"}
              onChange={handlePayTypeAutoComp}
              disabled={!formData?.variantType}
            />
          </Box>

          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
              ;
            </Backdrop>
          )}
          <SubmitButton
            hasNote="No"
            disabled={
              !formData?.accountNo ||
              !formData?.reAccountNo ||
              !formData?.ifsc ||
              !formData?.paymentType ||
              !formData?.bankName ||
              accountErr ||
              reAccountErr ||
              ifscErr
            }
          />
        </form>
      </Container>
    </>
  );
}
